import {gsap} from "gsap";
import {CustomEase} from "gsap/CustomEase";
import {Helpers} from '@js/utils/helpers'

export class Cursor {

  isCallable() {
    return window.innerWidth > 1024
  }

  init() {
    const mask = document.querySelector('.bg-grid__reveal');
    const {mapRange} = gsap.utils;

    gsap.registerPlugin(CustomEase);

    document.addEventListener('pointermove', (pos) => {

      let x = mapRange(
        0, window.innerWidth,
        0, 100,
        pos.clientX
      );
      let y = mapRange(
        0, window.innerHeight,
        0, 100,
        pos.clientY
      );

      gsap.to(mask,{
        '--mouse-x': x + '%',
        animationDelay: 0.3
      })
      gsap.to(mask,{
        '--mouse-y': y + '%',
        animationDelay: 0.3
      })

    });

    document.addEventListener('mousedown', () => {
      gsap.set(mask,{
        'display': 'none'
      })
    });

    document.addEventListener('mouseup', () => {
      gsap.set(mask,{
        'display': 'block'
      })
    });
  }


}
